import React, { useEffect, useState } from 'react'
import { Card, IconButton } from '@material-ui/core'
import {
  postMaterialsEcualizador,
  getEcualizador,
  getFiltersEcualizador,
  setEcualizador,
  setEcualizadorPrev,
  setMaterialManual,
  getRolUser,
} from '@auteco/services/snopServices'
import { Alert } from '@auteco/components/snopComponents/Alert'
import MaterialTable from '@material-table/core'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import PanToolOutlinedIcon from '@material-ui/icons/PanToolOutlined'
import PanToolIcon from '@material-ui/icons/PanTool'
import { initialAlert } from '@auteco/constants'
import { MaterialsFilters } from '../MaterialsFilters'
import useStyles from './styles'
import EqualizerGraphs from '../EqualizerGraphs/EqualizerGraphs'
import Button from '../../sharedComponents/CustomButtons/Button'
import Modal from '../Modal/Modal'
import './MarkingSection.css'
import Tooltip from '../Tooltip/Tooltip'

const MarkingSection = () => {
  const [infoBars, setInfoBars] = useState('')

  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState([])
  const [materials, setMaterials] = useState([])
  const [ecualizadorPreMaterials, setEcualizadorPreMaterials] = useState([])

  const [mape, setMape] = useState(100)
  const [bias, setBias] = useState(100)
  const [deltaCosto, setDeltaCosto] = useState(100)
  const [disponibilidad, setDisponibilidad] = useState(100)

  const [isModalOpen, setModalOpen] = useState(false)

  const [selectedFilters, setSelectedFilters] = useState([])

  const [materialForSearch, setMaterialForSearch] = useState('')
  const [alertInfo, setAlertInfo] = useState(initialAlert)

  const [onReset, setOnReset] = useState(false)

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }

  const getInfoBars = async () => {
    const response = await getRolUser()
    if (response) {
      setInfoBars(response.iam.nombre)
    }
  }

  const classes = useStyles()

  const rowStyle = (rowData, index) => {
    if (rowData.primer_ingreso && rowData.porc_bias === undefined) {
      return { backgroundColor: '#ff5449', padding: '5px', fontSize: '12px' }
    }
    if (rowData.primer_ingreso && rowData.porc_mape === undefined) {
      return { backgroundColor: '#fea500', padding: '5px', fontSize: '12px' }
    }
    if (index % 2 !== 0) {
      return { backgroundColor: '#f0f0f0', padding: '5px', fontSize: '12px' }
    }
    return { padding: '5px', fontSize: '12px' }
  }

  const handleSliderChange = (variable, value) => {
    switch (variable) {
      case 'MAPE':
        setMape(value)
        break
      case 'BIAS':
        setBias(value)
        break
      case 'DELTA COSTO':
        setDeltaCosto(value)
        break
      case 'DISPONIBILIDAD':
        setDisponibilidad(value)
        break
      default:
        break
    }
  }

  const handleClickMaterialGraph = (id) => {
    setMaterialForSearch(`${id}`)
  }

  const getFiltersApi = async () => {
    setLoading(true)
    const { filtros } = await getFiltersEcualizador()
    setFilters(filtros)
    setLoading(false)
  }
  const getEcualizadorApi = async () => {
    setLoading(true)
    const ecualizador = await getEcualizador()
    if (ecualizador) {
      setMape(ecualizador.mape)
      setBias(ecualizador.bias)
      setDeltaCosto(ecualizador.cambio_costo)
      setDisponibilidad(ecualizador.disponibilidad)
    }
    setLoading(false)
  }

  const onFilter = async ({ form }) => {
    setLoading(true)
    const data = await postMaterialsEcualizador({ params: form })
    setSelectedFilters(form)
    setMaterials(
      data.materiales.map((material, index) => ({
        ...material,
        tableIndex: index,
      })),
    )
    setLoading(false)
  }

  const handleSendEqualizer = async () => {
    setLoading(true)
    const ecualizador = {
      mape,
      bias,
      cambio_costo: deltaCosto,
      disponibilidad,
      materiales: [...new Set(materials.map((material) => `${material.id}`))],
    }
    const listPreEcua = await setEcualizador(ecualizador)
    if (listPreEcua.success) {
      setOnReset(true)
      handleCloseModal()
      setAlertInfo({
        title: 'Completado',
        content: 'La sincronización se ha completado con éxito',
        textBtn1: 'Cerrar',
        textBtn2: '',
        open: true,
        onClose: onCloseAlert,
        funcBtn: onCloseAlert,
      })
    } else {
      setAlertInfo({
        title: 'Error',
        content: 'No se pudo realizar la sincronización',
        textBtn1: 'Cerrar',
        textBtn2: '',
        open: true,
        onClose: onCloseAlert,
        funcBtn: onCloseAlert,
      })
      handleCloseModal()
    }
    setLoading(false)
  }

  const updateEqualizer = async () => {
    setLoading(true)
    const ecualizador = {
      mape,
      bias,
      cambio_costo: deltaCosto,
      disponibilidad,
      materiales: [...new Set(materials.map((material) => `${material.id}`))],
    }
    const listPreEcua = await setEcualizadorPrev(ecualizador)

    if (listPreEcua.materiales) {
      if (listPreEcua.materiales.length > 0) {
        setEcualizadorPreMaterials(listPreEcua.materiales)
        setModalOpen(true)
      } else {
        handleSendEqualizer()
      }
    } else {
      console.log('error en api equalizer prev')
    }
    setLoading(false)
  }

  const sendMaterialManual = async (id, status) => {
    const body = {
      material: id,
      estado: status,
    }
    const response = await setMaterialManual(body)
    console.log('#######', response)

    if (response.success === 1) {
      onFilter({ form: selectedFilters })
    }
  }

  useEffect(() => {
    getInfoBars()
    getFiltersApi()
    getEcualizadorApi()
  }, [])

  const obligatoryCount = materials.filter((item) => item.obligatorio).length

  const columns = [
    {
      title: 'Index',
      field: 'tableIndex',
      hidden: true,
    },
    {
      title: `Obligatorio (${obligatoryCount})`,
      field: 'obligatorio',
      render: (rowData) =>
        rowData.obligatorio ? (
          <CheckCircleIcon />
        ) : (
          <RadioButtonUncheckedIcon />
        ),
    },
    {
      title: 'Material',
      field: 'id',
    },
    {
      title: 'Descripción',
      field: 'texto',
    },
    {
      title: 'Subcategoria',
      field: 'subcategoria',
    },
    {
      title: 'Marca',
      field: 'marca',
    },
    {
      title: 'Mape',
      field: 'porc_mape',
      render: (rowData) =>
        rowData.porc_mape !== undefined ? (
          `${Math.round(rowData.porc_mape * 10000) / 100} %`
        ) : rowData.porc_mape ? (
          <p>⚠️</p>
        ) : (
          <p>📦</p>
        ),
    },
    {
      title: 'Bias',
      field: 'porc_bias',
      render: (rowData) =>
        rowData.porc_bias !== undefined ? (
          `${Math.round(rowData.porc_bias * 10000) / 100} %`
        ) : rowData.primer_ingreso ? (
          <p>💀</p>
        ) : (
          <p>📦</p>
        ),
    },

    {
      title: 'Delta Costos',
      field: 'porc_cambio_costo',
      render: (rowData) =>
        rowData.porc_cambio_costo !== undefined
          ? `${Math.round(rowData.porc_cambio_costo * 10000) / 100} %`
          : '',
    },
    {
      title: 'Disponibilidad',
      field: 'porc_disponibilidad',
      render: (rowData) =>
        rowData.porc_disponibilidad !== undefined
          ? `${Math.round(rowData.porc_disponibilidad * 10000) / 100} %`
          : '',
    },
    {
      title: 'Mape ecu',
      field: 'porc_mape_norm',
    },
    {
      title: 'Bias ecu',
      field: 'porc_bias_norm',
    },
    {
      title: 'Delta ecu',
      field: 'porc_cambio_costo_norm',
    },
    {
      title: 'Disp ecu',
      field: 'porc_disponibilidad_norm',
    },
    {
      title: '',
      field: 'obligatorio_manual',
      render: (rowData) =>
        rowData.obligatorio_manual ? (
          <IconButton
            onClick={() => {
              sendMaterialManual(rowData.id, 0)
            }}
          >
            <PanToolIcon />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => {
              sendMaterialManual(rowData.id, 1)
            }}
          >
            <PanToolOutlinedIcon />
          </IconButton>
        ),
    },
  ]

  const columnsModal = [
    {
      title: 'Material',
      field: 'id',
    },
    {
      title: 'Subcategoria',
      field: 'subcategoria',
      sorting: false,
    },
    {
      title: 'Marca',
      field: 'marca',
      sorting: false,
    },
    {
      title: 'Mape',
      field: 'porc_mape_norm',
      sorting: false,
    },
    {
      title: 'Bias',
      field: 'porc_bias_norm',
      sorting: false,
    },
    {
      title: 'Delta',
      field: 'porc_cambio_costo_norm',
      sorting: false,
    },
    {
      title: 'Disponibilidad',
      field: 'porc_disponibilidad_norm',
      sorting: false,
    },
  ]
  if (infoBars && infoBars !== 'Gerente') {
    return <p>Permisos insuficientes</p>
  }

  function inverseLogisticP(y) {
    y /= 100
    if (y < 0 || y > 1) {
      throw new Error('El valor de y debe estar en el rango (0, 1)')
    }
    const result = -Math.log((1 - y) / (y + 1))
    return result
  }

  return (
    <>
      <Alert
        title={alertInfo.title}
        content={alertInfo.content}
        textBtn1={alertInfo.textBtn1}
        textBtn2={alertInfo.textBtn2}
        funcBtn={alertInfo.funcBtn}
        open={alertInfo.open}
        onClose={onCloseAlert}
      />
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <h3> Atención</h3>
        <p>Estos materiales ya fueron asignados</p>
        <div className="zoom-out">
          {' '}
          <MaterialTable
            title=""
            data={materials}
            columns={columnsModal}
            style={{ marginTop: '0px' }}
            options={{
              sorting: false,
              thirdSortClick: false,
              headerStyle: {
                backgroundColor: '#4c75aa',
                color: '#f1f1f1',
                fontSize: '12px',
                fontWeight: 700,
              },
              rowStyle,
              pageSize: 20,
              pageSizeOptions: [20, 50, 100],
            }}
          />
        </div>
        <button className="button-alert" onClick={() => handleSendEqualizer()}>
          Continuar
        </button>
        <button className="button-alert" onClick={handleCloseModal}>
          {' '}
          Cancelar{' '}
        </button>
      </Modal>
      <Card className={classes.cardContainer}>
        <Card className={classes.grayCard}>
          {filters.length > 0 ? (
            <MaterialsFilters
              loading={loading}
              filters={filters}
              onFilter={onFilter}
              onReset={onReset}
              setOnReset={setOnReset}
            />
          ) : (
            <h4 style={{ padding: '20px' }}>Cargando ⏳</h4>
          )}
          {materials.length > 0 && (
            <>
              <Card className={classes.equalizerContainer}>
                <div className={classes.equalizerBoard}>
                  <div className={classes.equalizerActionBoard}>
                    <div className={classes.equalizer_item}>
                      <div className="title-eq-container">
                        <Tooltip text="Indica cuán cerca están las proyecciones de lo real respecto a lo real, es decir, lo ideal es que el MAPE se acerque a cero.">
                          <p className="int-button">?</p>
                        </Tooltip>
                        <p>{`Mape [ ${mape} ] [ ${
                          inverseLogisticP(mape).toFixed(2) * 100
                        }% ]`}</p>
                      </div>

                      <div className="input-container">
                        <input
                          type="range"
                          id="mape"
                          min="1"
                          max="99"
                          className="slider1"
                          value={mape}
                          onChange={(e) =>
                            handleSliderChange('MAPE', e.target.value)
                          }
                        />
                        <div className="values-container">
                          <p>0</p>
                          <p>100</p>
                        </div>
                      </div>
                    </div>
                    <div className={classes.equalizer_item}>
                      <div className="title-eq-container">
                        <Tooltip text="Indica, en un LEADTIME, cuán cerca están las proyecciones de lo real respecto a lo real, es decir, lo ideal es que el BIAS se acerque a cero. Si este es positivo (+), se ha sobreestimado la demanda, si es negativo (-), se ha subestimado la demanda.">
                          <p className="int-button">?</p>
                        </Tooltip>
                        <p>{`Bias [ ${bias} ] [ ${
                          [inverseLogisticP(bias).toFixed(2)] * 100
                        }% ]`}</p>
                      </div>

                      <div className="input-container">
                        <input
                          type="range"
                          id="bias"
                          min="1"
                          max="99"
                          value={bias}
                          className="slider2"
                          onChange={(e) =>
                            handleSliderChange('BIAS', e.target.value)
                          }
                        />
                        <div className="values-container">
                          <p>0</p>
                          <p>100</p>
                        </div>
                      </div>
                    </div>
                    <div className={classes.equalizer_item}>
                      <div className="title-eq-container">
                        <Tooltip text="Variación del costo del mes T-1 respecto del mes T-2. Un delta positivo (+), indica que incrementó el costo, si es negativo (-), hubo decremento en el costo.">
                          <p className="int-button">?</p>
                        </Tooltip>
                        <p>{`Delta Costo [ ${deltaCosto} ] [ ${
                          inverseLogisticP(deltaCosto).toFixed(2) * 100
                        }% ]`}</p>
                      </div>
                      <div className="input-container">
                        <input
                          type="range"
                          id="deltaCosto"
                          min="1"
                          max="99.9"
                          value={deltaCosto}
                          className="slider3"
                          onChange={(e) =>
                            handleSliderChange('DELTA COSTO', e.target.value)
                          }
                        />
                        <div className="values-container">
                          <p>0</p>
                          <p>100</p>
                        </div>
                      </div>
                    </div>

                    <div className={classes.equalizer_item}>
                      <div className="title-eq-container">
                        <Tooltip text="porcentaje, del mes anterior, en el que tuve agotados, donde, 0 indica que no hubo agotados y 100 que estuvo agotado todo el mes.">
                          <p className="int-button">?</p>
                        </Tooltip>
                        <p>{`Agotados [ ${disponibilidad} ] [ ${
                          inverseLogisticP(disponibilidad).toFixed(2) * 100
                        }% ]`}</p>
                      </div>
                      <div className="input-container">
                        <input
                          type="range"
                          id="disponibilidad"
                          min="1"
                          max="99"
                          value={disponibilidad}
                          className="slider4"
                          onChange={(e) =>
                            handleSliderChange('DISPONIBILIDAD', e.target.value)
                          }
                        />
                        <div className="values-container">
                          <p>0</p>
                          <p>100</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Button
                    onClick={() => updateEqualizer()}
                    type="onSubmit "
                    color="warning"
                    disabled={loading}
                  >
                    ASIGNAR
                  </Button>
                </div>

                <EqualizerGraphs
                  data={materials}
                  mapeY={mape}
                  biasY={bias}
                  deltaY={deltaCosto}
                  dispY={disponibilidad}
                  handleClickMaterialGraph={handleClickMaterialGraph}
                  inverseLogisticP={inverseLogisticP}
                />
              </Card>
            </>
          )}
          <MaterialTable
            title=""
            key={materialForSearch}
            isLoading={loading}
            data={materials}
            columns={columns}
            style={{ marginTop: '20px' }}
            options={{
              sorting: false, // Deshabilita el ordenamiento global

              rowStyle,
              pageSize: 20,
              pageSizeOptions: [20, 50, 100],
              headerStyle: {
                backgroundColor: '#4c75aa',
                color: '#f1f1f1',
                fontSize: '14px',
                fontWeight: 700,
                position: 'sticky', zIndex: '10'
              },
              maxBodyHeight: '500px',
              search: true,
              searchFieldAlignment: 'right',
              searchFieldStyle: {
                fontSize: '14px',
              },
              searchText: materialForSearch,
            }}
          />{' '}
        </Card>
      </Card>
    </>
  )
}
export { MarkingSection }
